const ALPHABET = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

const getAlphabetLetterAt = index =>
  ALPHABET[index % ALPHABET.length];

export default getAlphabetLetterAt;
